import './style.less';

export default function() {}



// WEBPACK FOOTER //
// ./src/app/components/forms/singleLineResponses/view/controller.js